"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PolicySummaryPriceWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var journey_services_1 = require("@ferry/journey-services");
var commonFunctions_1 = require("../commonFunctions");
var PolicySummaryPriceWidget = /** @class */ (function (_super) {
    __extends(PolicySummaryPriceWidget, _super);
    function PolicySummaryPriceWidget() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PolicySummaryPriceWidget.prototype.render = function () {
        var _a = this.props, price = _a.price, premiumType = _a.premiumType, totalPaid = _a.totalPaid;
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [price >= 0 && (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("span", { className: "d-flex justify-content-end", children: premiumType === journey_services_1.PREMIUM_TYPE_ANNUAL ? "Annual price" : "Price" }), (0, jsx_runtime_1.jsxs)("div", { className: "d-flex justify-content-end", children: [(0, jsx_runtime_1.jsx)("span", { className: "h3 d-flex font-weight-bold", children: (0, commonFunctions_1.getAmountWithDecimalDigits)(price) }), (0, jsx_runtime_1.jsxs)("span", { className: "font-weight-bold", children: [" / ", "".concat(premiumType === journey_services_1.PREMIUM_TYPE_ANNUAL ? "year*" : "month*")] })] })] }), premiumType !== journey_services_1.PREMIUM_TYPE_ANNUAL &&
                    (0, jsx_runtime_1.jsx)("div", { className: "d-flex justify-content-end", children: (0, jsx_runtime_1.jsxs)("p", { className: "m-0", children: ["You pay ", (0, jsx_runtime_1.jsx)("span", { className: "font-weight-bold", children: (0, commonFunctions_1.getAmountWithDecimalDigits)(totalPaid) }), " in total"] }) })] }));
    };
    return PolicySummaryPriceWidget;
}(React.Component));
exports.PolicySummaryPriceWidget = PolicySummaryPriceWidget;
//# sourceMappingURL=PolicySummaryPriceWidget.js.map